<i18n>
{
  "es": {
    "workBlockingTitle": "Bloquear Trabajo",
    "workBlockingDescription": "La orden será movida al estado 'Trabajo Bloqueado'. Debe ingresar una nota explicando el motivo del bloqueo.",
    "blockingNotesLabel": "Notas del bloqueo de trabajo",
    "blockingNotesPlaceholder": "Ingrese el motivo del bloqueo...",
    "blockingNotesRequired": "Las notas de bloqueo son obligatorias",
    "cancel": "Cancelar",
    "confirmBlocking": "Confirmar Bloqueo"
  },
  "en": {
    "workBlockingTitle": "Block Work",
    "workBlockingDescription": "The order will be moved to 'Work Blocked' status. You must enter a note explaining the reason for the block.",
    "blockingNotesLabel": "Work blocking notes",
    "blockingNotesPlaceholder": "Enter the reason for blocking...",
    "blockingNotesRequired": "Blocking notes are required",
    "cancel": "Cancel",
    "confirmBlocking": "Confirm Block"
  }
}
</i18n>

<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="480px" persistent>
      <v-card>
        <v-card-title class="primary--text">
          <v-icon left color="primary">mdi-lock-outline</v-icon>
          {{ $t('workBlockingTitle') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <p class="text-body-2 mb-4">{{ $t('workBlockingDescription') }}</p>
          <v-textarea
            v-model="blockingNotes"
            :label="$t('blockingNotesLabel')"
            :rules="[v => !!v && v.trim().length > 0 || $t('blockingNotesRequired')]"
            outlined
            auto-grow
            rows="6"
            required
            ref="blockingNotesField"
          ></v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="cancel">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            :disabled="!isNotesValid"
            @click="confirm"
          >
            {{ $t('confirmBlocking') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'WorkBlockingModal',

  data() {
    return {
      dialog: false,
      blockingNotes: '',
      pendingOrder: null,
      pendingStatusId: null
    };
  },

  computed: {
    isNotesValid() {
      return this.blockingNotes && this.blockingNotes.trim().length > 0;
    }
  },

  methods: {
    countExistingBlocks(notes) {
      if (!notes) return 0;
      const matches = notes.match(/Bloqueo \d+(?:\(SOLUCIONADO\))?:/g);
      return matches ? matches.length : 0;
    },

    open(order, targetStatusId) {
      this.pendingOrder = order;
      this.pendingStatusId = targetStatusId;
      const existing = order.blockingNotes || '';
      const nextNumber = this.countExistingBlocks(existing) + 1;
      const nextLabel = `Bloqueo ${nextNumber}: `;
      this.blockingNotes = existing ? `${existing}\n${nextLabel}` : nextLabel;
      this.dialog = true;
    },

    confirm() {
      if (!this.isNotesValid) return;
      this.$emit('confirm', {
        order: this.pendingOrder,
        targetStatusId: this.pendingStatusId,
        blockingNotes: this.blockingNotes.trim()
      });
      this.reset();
    },

    cancel() {
      this.$emit('cancel');
      this.reset();
    },

    reset() {
      this.dialog = false;
      this.blockingNotes = '';
      this.pendingOrder = null;
      this.pendingStatusId = null;
    }

  }
};
</script>
